<template>
  <div class="main-container">
    <!-- breadcrumb -->
    <!-- <ul class="breadcrumb">
      <li>
        <a href="#">Payroll</a>
      </li>
      <li>
        <a href="#">Utilities</a>
      </li>
      <li>Retirement Setting</li>
    </ul>-->
    <breadcrumb :list="breadCrumbList" />
    <!-- breadcrumb -->

    <tl-header type="h1" class="label input-label margintop-20">Retirement Settings</tl-header>
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />
    <div class="flex-container">
      <div class="input-label">Enter Age of Retirement</div>
      <txt type="text" name="name" v-model="formData.ageOfRetirement" />
      <div class="input-label">Years</div>
    </div>
    <div class="margintop-20">
      <tl-select
        class="custom-width"
        label="Retirement Criteria"
        :options="optionsData"
        v-model="formData.criteria"
        @change="(val)=>formData.criteria = val"
        name="retirementCriteria"
      ></tl-select>
    </div>
    <article>
      <bottom-action-container>
        <template slot="end">
          <btn-grp>
            <btn text="Cancel" type="secondary" />
            <btn text="Save" type="primary" @click="save()" />
          </btn-grp>
        </template>
      </bottom-action-container>
    </article>
    <pop-up-message
      v-if="showSuccessMsg"
      :message="`Retirement data added successfully`"
      btnText="Back To"
      @back="backfrompopup()"
    />
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      getLegalEntityId: "onboard/legal_entities/legal_entity_ID"
    }),
    leId() {
      if (this.$route.params.entity_index) {
        return this.getLegalEntityId(this.$route.params.entity_index);
      }
      return this.getLegalEntityId(0);
    }
  },
  data() {
    return {
      breadCrumbList: [
        {
          name: "Payroll",
          url: `/dashboard/${this.$route.params.entity_index}/payroll/monthlypayroll`
        },
        {
          name: "Utilities",
          url: `/dashboard/${this.$route.params.entity_index}/payroll/utilities`
        },
        {
          name: "Retirement Setting",
          url: ""
        }
      ],
      toast:false,
      errmsg:'',
      showSuccessMsg: false,
      formData: {
        criteria: "",
        retirementSettingOn:"",
        idOfSettingOn:"",
        ageOfRetirement: ""
      },
      blankFormData: {
        criteria: "",
        retirementSettingOn:"",
        idOfSettingOn:"",
        ageOfRetirement: ""
      },
      optionsData: ["Retirement Date", "End of the month"]
    };
  },
  methods: {
    ...mapActions("dashboard/retirementSettings/", {
      act_create: "create"
    }),
    refresh() {
      this.formData = this.$_.cloneDeep(this.blankFormData);
      this.$validator.reset();
    },
    async save() {
      try {
        //console.log(this.formData);
        this.$root._data.isSaving = true;
        let res = await this.act_create({
          ...this.formData,
          le_id: this.leId
        });
        setTimeout(() => {
          if (res.data.status) {
            this.showSuccessMsg = true;
            this.refresh();
          }
          this.$root._data.isSaving = false;
        }, 500);
      } catch (error) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = error;
      }
    },
    backfrompopup() {
      this.showSuccessMsg = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.flex-container {
  display: flex;
  align-items: center;
}

.flex-container > div {
  margin-right: 10px;
}
.custom-width {
  width: 300px;
}
</style>
